/* eslint-disable */
import log from "salvo-lite/log";
import EventBus from "../helpers/event-bus";
import axios from "axios";

class Cart {
  constructor(components) {
    this._name = this.constructor.name;
    this._components = components;

    this._selectors = {
      container: '[js-cart="container"]',
      form: ".template-cart__container",
      input_fiscal: "#fiscal-code",
      input_vin_reg: "#vin-reg",
      errors: ".error",
    };

    this._cartForm = document.querySelector(this._selectors.form);

    log.debug(this.constructor.name, "Constructed", this);
  }

  onInit() {
    /**
     * Global Frame utils
     */
    window.Frame = window.Frame || {};
    window.Frame.EventBus = EventBus();

    window.Frame.EventBus.listen("AjaxCart:cartEmpty", () => {
      document.querySelector(this._selectors.container).innerHTML = `
              <div class="template-cart__empty">
                <div class="row no-margin">
                  <div class="col s12 m6 offset-m3 text-center">
                    <h1>${window.theme.strings.cart.general.title}</h1>
                    <p>${window.theme.strings.cart.general.empty}</p>
                    <a href="/collections/all" class="button button--primary button--small">${window.theme.strings.cart.general.continueBrowsing}</a>
                  </div>
                </div>
              </div>
            `;
    });

    if (this._cartForm) {

      this._cartForm.addEventListener("submit", (event) => {
        this._validateForm(event);
      });
    }
  }

  // Originally directly commented out in theme.js
  // Re-enabled to ensure the VAT code is captured for EU, 
  // but left the VIN check disabled.
 async _validateForm(event) {
   event.preventDefault();

   this._removeValidationErrors();

   const errors = [];
   
  const inputVinReg = event.target.querySelector(
    this._selectors.input_vin_reg
  );

  if (inputVinReg) {
    const trimmedValue = inputVinReg.value.trim();

    if (trimmedValue === "") {
      errors.push({
        field: this._selectors.input_vin_reg,
        error: inputVinReg.dataset.validationValue,
      });
    } else if (trimmedValue.length > 17) {
      let errorMessage = inputVinReg.dataset.validationLength;
      if (errorMessage.includes("#")) {
        errorMessage = errorMessage.replace("#", inputVinReg.value.length);
      }
      errors.push({
        field: this._selectors.input_vin_reg,
        error: errorMessage,
      });
    } else {
      try {
        const payload = {
          attributes: {
            "FCJ VIN/REG": trimmedValue,
          },
        };
        await axios.post("/cart/update.json", payload);
      } catch (error) {
        console.log(error);
      }
    }
  }

  const inputFiscal = event.target.querySelector(
    this._selectors.input_fiscal
  );

  if (inputFiscal) {
    if (inputFiscal.value != "") {
      const validFiscal = this._isValidFiscal(inputFiscal.value.trim());
      if (!validFiscal) {
        errors.push({
          field: this._selectors.input_fiscal,
          error: inputFiscal.dataset.validationValue,
        });
      }
      try {
        const payload = {
          attributes: {
            "TaxPayerID": inputFiscal.value.trim(),
          },
        };
        await axios.post("/cart/update.json", payload);
      } catch (error) {
        console.log(error);
      }
    }
  }

   // If there are errors, display them
   // and bail early
   if (errors.length) {
     this._showValidationErrors(errors);
     this._scrollToFirstError();
     return;
   }

   // No errors, off you go
   this._cartForm.submit();
 }

_isValidFiscal(s) {
  try {
    // Trim whitespace from start and end
    s = s.trim();
    
    // Check if any whitespace exists in the middle
    if (s.includes(' ')) {
      return false; 
    }
    
    // Check length
    if (s.length !== 16) {
      return false;
    }

    try {
      const m = s.match(/^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i);
      return m ? !!new RegExp(m[2],m[3])
          : false;
    } catch (e) {
      return false
    }

  } catch (e) {
    return false;
  }
}

 _showValidationErrors(errors) {
   errors.forEach((errorObject) => {
     const inputField = document.querySelector(errorObject.field);
     const inputGroup = inputField.closest(".esc-input-group");
     const errorElement = inputGroup.querySelector(".error");
     inputField.setAttribute("aria-invalid", true);
     errorElement.innerText = errorObject.error;
     errorElement.classList.add("is-active");
     errorElement.setAttribute("aria-hidden", false);
   });
 }

  _removeValidationErrors() {
    const errors = document.querySelectorAll(this._selectors.errors);
    errors.forEach((element) => {
      element.classList.remove("is-active");
      element.setAttribute("aria-hidden", true);
    });
  }

  _scrollToFirstError() {
    const firstError = document.querySelector(".error.is-active");
    firstError.scrollIntoView();
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Cart.js